import { render, staticRenderFns } from "./SolicitudesProducto.vue?vue&type=template&id=b8e9f9e8&"
import script from "./SolicitudesProducto.vue?vue&type=script&lang=js&"
export * from "./SolicitudesProducto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QToolbar,QToolbarTitle,QBtn,QTable,QTr,QTd,QSelect} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QToolbar,QToolbarTitle,QBtn,QTable,QTr,QTd,QSelect})
